<template>
  <b-modal id="modal-editar-destaque-carrossel" dialog-class="modal-conta" size="xl" hide-header hide-footer :no-enforce-focus="true">
    <form>
      <h6>Editar Destaque de Carrossel</h6>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <form-group id="tipoStatus" label="" :text="{ required: 'Obrigatório informar o status do destaque' }" :field="$v.destaque.status">
            <div class="custom-control custom-switch status-destaque-switch">
              <input name="tipoStatus" type="checkbox" class="custom-control-input" id="customSwitch1" v-model="destaque.status" v-bind:true-value="1" v-bind:false-value="0">
              <label class="custom-control-label" for="customSwitch1"><strong style="line-height: 23px;">Destaque {{ destaque.status == 1 ? 'Ativo' : 'Inativo' }}</strong></label>
            </div>
          </form-group>
        </div>
      </div>
      <div class="col-12 col-md-12" v-if="destaque.status == '1'">
        <div class="form-group">
          <form-group id="tipoStatus" :text="{ required: 'Obrigatório informar o status do destaque' }" :field="$v.destaque.ordem">
            <label for="tipo_fonte"><strong>Ordem de destaque no carrossel</strong></label>
            <select class="form-control col-12 col-md-6 mt-2" v-model="destaque.ordem"  :text="{ required: 'Obrigatório informar o tipo da fonte' }">
              <option value="1">Primeiro</option>
              <option value="2">Segundo</option>
              <option value="3">Terceiro</option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <strong>Preview (aproximado) das imagens atuais</strong>
          <div class="row mt-2">
            <div class="col-md-8">
              <div v-if="this.imagemDesktop" id="imgContainer" :style="'border: 1px solid black;height: 300px;background-position: center;background-size:cover;background-image:url(' + imagemDesktop + ')'"></div>
              <div v-else-if="destaqueEdicao && destaqueEdicao.imagens" id="imgContainer" :style="'border: 1px solid black;height: 300px;background-position: center;background-size:cover;background-image:url(' + obterUrlS3(destaqueEdicao.imagens.url) + ');'"></div>
            </div>
            <div class="col-md-4">
              <div v-if="this.imagemMobile" id="imgContainerMobile" :style="'border: 1px solid black;height: 300px;background-position: center;background-size:cover;background-image:url(' + imagemMobile + ')'"></div>
              <div v-else-if="destaqueEdicao && destaqueEdicao.imagens" id="imgContainerMobile" :style="'border: 1px solid black;height: 300px;background-position: center;background-size:cover;background-image:url(' + obterUrlS3(destaqueEdicao.imagens_mobile.url) + ');'"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label for="imagemCurso"><strong>Upload de imagem - versão desktop</strong></label>
          <div class="input-group mb-3">
            <b-form-file
              v-model="destaque.imagemDesktop"
              placeholder="Escolha uma imagem"
              drop-placeholder="Solte um arquivo aqui..."
              browse-text="Selecionar"
              accept="image/jpeg, image/png"
              @change="onFileInputDesktop($event)"
            ></b-form-file>
            <span class="mt-1 col-12">Utilize imagens png, com tamanho de 734 x 320px e conteúdo centralizado.</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <label for="imagemCurso"><strong>Upload de imagem - versão mobile</strong></label>
          <div class="input-group mb-3">
            <b-form-file
              v-model="destaque.imagemMobile"
              placeholder="Escolha uma imagem"
              drop-placeholder="Solte um arquivo aqui..."
              browse-text="Selecionar"
              accept="image/jpeg, image/png"
              @change="onFileInputMobile($event)"
            ></b-form-file>
            <span class="mt-1 col-12">Utilize imagens png, com tamanho de 450 x 300px e conteúdo centralizado.</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12">
        <div class="form-group">
          <form-group id="destaqueDestino" :text="{ https: 'A url deve possuir https', required: 'O destino do destaque é um campo obrigatório' }" :field="$v.destaque.destino_url">
            <label for="destino_url"><strong>Destino do destaque *</strong></label>
            <input type="text" class="form-control" id="destino_url" v-model="destaque.destino_url" placeholder="ex.: https://jaleko.com.br/curso/neuroanatomia"/>
          </form-group>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="$bvModal.hide('modal-editar-destaque-carrossel')">Cancelar</a>
          <a href="javascript:void(0)" id='editar' class="btn btn-primary mr-3 mb-2 mb-md-0" v-if="destaqueEdicao" @click="editar">Editar</a>
          <a href="javascript:void(0)" id='cadastrar' class="btn btn-primary mr-3 mb-2 mb-md-0" v-else @click="salvar">Salvar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import FormGroup from '@/core/components/FormGroup'
import { required, helpers } from 'vuelidate/lib/validators'
import ResponseUtils from '@/core/util/response-utils'
import UrlUtils from '@/core/util/url-utils'
import DestaqueAPI from '@/api/destaque-api'
const https = helpers.regex('https', /https:\/\/+/)

export default {
  name: 'ModalEditarDestaqueCarrossel',
  inheritAttrs: false,
  components: {
    FormGroup
  },
  props: {
    destaqueEdicao: Object,
    tipo: Number
  },
  data () {
    return {
      destaque: Object,
      imagemDesktop: null,
      imagemMobile: null
    }
  },

  validations: {
    destaque: {
      status: { required },
      ordem: { required },
      destino_url: { required, https }
    }
  },

  mounted () {
    this.destaque = {
      status: 0,
      ordem: '1',
      destino_url: ''
    }
  },

  methods: {
    obterUrlS3: function (arquivo) {
      return "'" + String(UrlUtils.obterUrlS3(arquivo)) + "'"
    },

    onFileInputDesktop: function (event) {
      const data = URL.createObjectURL(event.target.files[0])
      this.destaque.imagemDesktop = event.target.files[0]
      this.imagemDesktop = data
    },

    onFileInputMobile: function (event) {
      const data = URL.createObjectURL(event.target.files[0])
      this.destaque.imagemMobile = event.target.files[0]
      this.imagemMobile = data
    },

    show: function () {
      this.$v.$reset()
      this.$bvModal.show('modal-editar-destaque-carrossel')
      if (!this.destaqueEdicao) {
        this.destaque = {
          status: 0,
          ordem: '1',
          destino_url: '',
          tipo_destaque: this.tipo,
          imagemDesktop: null,
          imagemMobile: null
        }
      } else {
        this.destaque = this.destaqueEdicao
      }
      this.imagemDesktop = null
      this.imagemMobile = null
    },

    salvar: function () {
      this.$v.destaque.$touch()
      if (!this.$v.destaque.$invalid) {
        const loader = this.$loading.show()

        DestaqueAPI.salvar(this.destaque).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Ok',
            title: 'Destaques salvo com sucesso!'
          }).then((result) => {
            if (result.value) {
              this.destaque = []
              this.$emit('destaqueEditado')
              this.$bvModal.hide('modal-editar-destaque-carrossel')
            } else {
              this.$bvModal.hide('modal-editar-destaque-carrossel')
            }
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },

    editar: function () {
      this.$v.destaque.$touch()
      const loader = this.$loading.show()

      let destaqueEditado = {
        id: this.destaque.id,
        status: this.destaque.status,
        ordem: this.destaque.ordem,
        destino_url: this.destaque.destino_url,
        tipo_destaque: this.destaque.tipo_destaque,
        imagemDesktop: this.destaque.imagemDesktop,
        imagemMobile: this.destaque.imagemMobile
      }
      DestaqueAPI.atualizar(destaqueEditado).then(data => {
        loader.hide()

        Swal.fire({
          icon: 'success',
          confirmButtonText: 'Ok',
          title: 'Destaques atualizado com sucesso!'
        }).then(() => {
          this.destaque = []
          this.$emit('destaqueEditado')
          this.$bvModal.hide('modal-editar-destaque-carrossel')
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  }
}
</script>
